export const getShareLink = (shareTo: 'facebook' | 'x' | 'linkedin') => {
  const fullUrl =
    typeof window !== 'undefined' ? window.location.href : undefined;
  if (!fullUrl) return;
  const encodedUrl = encodeURIComponent(fullUrl);
  const shareLinks = {
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    x: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
  };
  return shareLinks[shareTo];
};
